<template>
    <div class="add-que">
        <p class="return pointer no-wrap font-size16" @click="gohomefunc">返回</p>
        <div style="margin-left: 0.15rem">
            <manage-title>新增试题</manage-title>
        </div>
        <div class="xy-start tabs">
            <div
                class="tab pointer"
                @click="activeTab = '单题新增'"
                :class="{ 'active-tab': activeTab === '单题新增' }"
            >
                单题新增
            </div>
            <div
                class="tab pointer"
                @click="activeTab = '智能录入'"
                :class="{ 'active-tab': activeTab === '智能录入' }"
            >
                智能录入
            </div>
        </div>
        <!-- 正文 -->

        <div v-if="activeTab === '单题新增'" class="content-one">
            <div class="condition xy-start">
                <div>
                    <div class="xy-center jf-start item">
                        <div class="name">题型:</div>
                        <el-select
                            v-model="queInfo.queType"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in queTypeData"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                    <div
                        class="xy-center jf-start item"
                        style="margin-top: 20px"
                    >
                        <div class="name">试题难度:</div>
                        <el-select
                            v-model="queInfo.difficulty"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in difficultyData"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <div class="xy-center jf-start item">
                        <div class="name">所属分类:</div>
                        <medical-class-selector
                            v-model="queInfo.type"
                            :add-all="false"
                        ></medical-class-selector>
                    </div>
                    <div
                        class="xy-center jf-start item"
                        style="margin-top: 20px"
                    >
                        <div class="name">试题用途:</div>
                        <el-select
                            v-model="queInfo.useFor"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="item in useForData"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div>
                    <div class="xy-center jf-start item">
                        <div class="name">知识点:</div>
                        <el-select
                            v-model="queInfo.KnowledgePoint"
                            placeholder="请选择"
                            clearable
                        >
                            <el-option
                                v-for="item in organInfo"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                                <div
                                    :style="{
                                        paddingLeft: `${
                                            item.parentIds.length * 20
                                        }px`,
                                    }"
                                >
                                    {{ item.label }}
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <!-- 添加试题 -->
            <div class="varied-que-type">
                <add-que-box
                    ref="queBox"
                    :que-type="queInfo.queType"
                    :is-new="true"
                ></add-que-box>
            </div>
            <!-- 底部按钮 -->
            <div class="xy-center bottom-btn">
                <el-button
                    type="primary"
                    :disabled="disableBtn"
                    @click="
                        goAdd(() => {
                            $router.push('/manage/resource/question');
                        })
                    "
                    :loading="flag.loading"
                    >保存并返回</el-button
                >
                <el-button
                    type="primary"
                    :disabled="disableBtn"
                    @click="goAdd()"
                    :loading="flag.loading"
                    >保存</el-button
                >
                <el-button
                    @click="
                        () => {
                            $router.go(-1);
                        }
                    "
                    >返回</el-button
                >
            </div>
        </div>
        <div v-if="activeTab === '智能录入'" class="content-two">
            <div class="condition xy-start">
                <div class="xy-center jf-start item">
                    <div class="name">所属分类:</div>
                    <medical-class-selector
                        v-model="queInfoTwo.type"
                        :add-all="false"
                    ></medical-class-selector>
                </div>
                <div class="xy-center jf-start item">
                    <div class="name">试题用途:</div>
                    <el-select v-model="queInfoTwo.useFor" placeholder="请选择">
                        <el-option
                            v-for="item in useForData"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="auto-add-ques">
                <auto-add-que ref="autoAdd"></auto-add-que>
            </div>

            <!-- 底部按钮 -->
            <div class="xy-center bottom-btn">
                <el-button
                    type="primary"
                    :disabled="!canBatchAdd"
                    :loading="flag.loading"
                    @click="
                        batchAdd(() => {
                            $router.push('/manage/resource/question');
                        })
                    "
                    >保存并返回</el-button
                >
                <el-button
                    type="primary"
                    :disabled="!canBatchAdd"
                    @click="batchAdd()"
                    :loading="flag.loading"
                    >保存</el-button>
                <el-button
                    @click="
                        () => {
                            $router.go(-1);
                        }
                    "
                    >返回</el-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import AutoAddQue from "@/components/manager/resource/AutoAddQue.vue";
import AddQueBox from "@/components/manager/resource/AddQueBox.vue";
import { CommonPage } from "@/mixins/commonData";
import { createQue, fetchOrgInfo, batchCreateQue } from "@/api/manage.js";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import ManageTitle from "@/components/manager/ManageTitle";
import { GetOrganPointInfo } from "@/api/category";
import { isEmpty } from "lodash";
import QuestionHelp from "@/mixins/questionHelp";
export default {
    mixins: [CommonPage, QuestionHelp],
    components: {
        ManageTitle,
        AutoAddQue,
        AddQueBox,
        MedicalClassSelector,
    },
    data() {
        return {
            activeTab: "单题新增",
            organInfo: [],
            queInfo: {
                type: "",
                queType: 1,
                difficulty: 2,
                useFor: 1,
                KnowledgePoint: "",
            },
            queInfoTwo: {
                type: "",
                useFor: 1,
            },
            flag: {
                loading: false,
            },
        };
    },
    mounted() {
        this.fetchOrganClass();
    },
    computed: {
        // 是否可以智能录入
        canBatchAdd() {
            return !this.disableBtn && this.$refs.autoAdd.canAdd
        },
        disableBtn() {
            let disable = false;
            for (let i in this.activeTab === "单题新增"
                ? this.queInfo
                : this.queInfoTwo) {
                if (this.activeTab === "单题新增") {
                    if (this.queInfo[i] == null || this.queInfo[i] === "") {
                        if (i === "KnowledgePoint") {
                            disable = false;
                        } else {
                            disable = true;
                            break;
                        }
                    }
                } else if (!(this.queInfoTwo[i] + "")) {
                    disable = !this.queInfoTwo[i];
                    break;
                } else {
                    disable = false;
                }
            }
            return disable;
        },
    },
    methods: {
        gohomefunc() {
            this.$router.go(-1)
        },
        fetchOrganClass() {
            const work = (newData, vl, pIds) => {
                for (let i = 0; i < vl.length; i++) {
                    newData.push({
                        label: vl[i].KnowledgePointName,
                        value: vl[i].Id,
                        parentIds: pIds,
                    });
                    // console.log("vl[i]:", vl[i]);
                    if (vl[i].children.length) {
                        work(
                            newData,
                            vl[i].children,
                            pIds.concat([vl[i].Id])
                        );
                    }
                }
            };
            GetOrganPointInfo().then((res) => {
                let newData = [];
                work(newData, res.data.data, []);
                this.organInfo = newData;
                // console.log("res:", res);
            });
        },
        resetData() {
            this.queInfo = {
                type: null,
                queType: 1,
                difficulty: 2,
                useFor: 1,
                KnowledgePoint: "",
            }
            this.$forceUpdate()
        },
        goAdd(event = () => {}) {
            const que = Object.assign({}, this.$refs.queBox.queData);
            const msg = this.verifyQues(que)
            if (msg) {
                this.$message.warning(msg)
                return;
            }
            if ([1, 2, 4].includes(que.SubjectType) && isEmpty(que.Answer)) {
                this.$message.warning("请选择答案")
                return
            }
            if (que.SubjectType === 2) {
                que.Answer = que.Answer.sort().join(",");
            }
            console.log("que:", que);
            this.flagPromise([
                createQue({
                    examSubjectModel: JSON.stringify({
                        ClassId: this.queInfo.type,
                        SubjectType: this.queInfo.queType,
                        HardLevel: this.queInfo.difficulty,
                        UseType: this.queInfo.useFor,
                        KnowledgePoint: this.queInfo.KnowledgePoint,
                        ...que,
                    }),
                }),
            ])
                .then((res) => {
                    this.$message.success("添加成功");
                    this.resetData()
                    this.$refs.queBox.initQueData();
                    event();
                })
                .catch((e) => {
                    this.$message.warning(e.msg);
                });
        },
        batchAdd(event = () => {}) {
            const queArr = this.$refs.autoAdd.queData;
            queArr.forEach((v) => {
                v.UseType = this.queInfoTwo.useFor;
                v.ClassId = this.queInfoTwo.type;
                if (v.SubjectType === 2 || v.SubjectType === 3) {
                    v.Answer = v.Answer.sort().join(",");
                }
                if (v.SubjectType === 5) {
                    this.answerToAnswerList(v)
                }
            });
            // console.log("queArr:", queArr);
            this.flagPromise([
                batchCreateQue({
                    examSubjectList: JSON.stringify(queArr),
                }),
            ]).then((res) => {
                this.$message.success("添加成功");
                this.$refs.autoAdd.clear()
                event();
            });
        },
        // 将回答题的Answer转换成AnswerList
        answerToAnswerList(que) {
            que.AnswerList = [{
                IsRight: 1,
                Content: que.Answer
            }]
        }
    },
};
</script>

<style lang="less" scoped>
.add-que {
    position: relative;
    .return{
        z-index: 10;
        color: #969799;
        position: absolute;
        top: 0.05rem;
        left: 0.1rem;
    }
    .tabs {
        margin-top: 30px;
        padding: 0 30px;
        .tab {
            width: 120px;
            height: 40px;
            border: 1px solid #e5e8ec;
            text-align: center;
            line-height: 40px;
        }
        .tab:nth-last-child(1) {
            border-left: none;
        }
        .active-tab {
            color: #fff;
            background: #0c95fd;
        }
    }
    .content-one {
        .condition {
            border: 1px solid #e5e8ec;
            padding: 20px;
        }
        .varied-que-type {
            margin-top: 30px;
            border: 1px solid #e5e8ec;
            padding: 30px;
        }
    }
    .content-two {
        .auto-add-ques {
            margin-top: 40px;
        }
    }
    .content-one,
    .content-two {
        margin: 30px 30px;
        .condition::v-deep {
            .item {
                margin-right: 50px;
                .name {
                    white-space: nowrap;
                    width: 4.5em;
                    font-size: 16px;
                    text-align: right;
                    padding-right: 5px;
                    box-sizing: border-box;
                }
            }
            .el-input {
                width: 210px;
                height: 34px;
                input {
                    height: 34px;
                    width: 210px;
                    ::placeholder {
                        font-size: 16px;
                    }
                }
            }
        }
        .bottom-btn {
            margin-top: 40px;
            & > .el-button {
                border-radius: 4px;
                padding: 0;
                height: 34px;
            }

            & > .el-button:nth-of-type(1) {
                width: 120px;
            }
            & > .el-button:nth-of-type(2),
            .el-button:nth-of-type(3) {
                width: 80px;
            }
        }
    }
}
</style>
